<template>
<div class="chapter">
<div class="inner_page">
<div class="acknowPage">
<div class="title-acknowPage"><a href="#/e9781466806597_toc01#toctitle1" id="title1"><span><em class="i">Acknowledgments</em></span></a></div>
<div class="p"><span>The author would like to acknowledge the advice and encouragement of the First Monday Quilters of Lexington, Massachusetts.</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781466806597_ack01.vue?76eb328e